<template>
  <div class="container">
    <div>
      <video
        class="videoscreen hidden"
        ref="video"
        controls
        autoplay
        playsinline
      ></video>
    </div>

    <md-button ref="startBtn" class="md-raised" id="btn-start-recording">
      <md-icon>fiber_smart_record</md-icon>
      Video-Aufnahme jetzt starten
    </md-button>

    <md-button
      ref="stopBtn"
      class="md-raised md-accent"
      id="btn-stop-recording"
      disabled
    >
      <md-icon>stop</md-icon>
      Aufnahme beenden
    </md-button>

    <div v-if="fileBlob">
      <hr />
      <md-button class="md-raised md-primary" @click.prevent="getDownload()">
        <md-icon>cloud_download</md-icon>
        Aufnahme herunterladen
      </md-button>
      <md-button
        v-if="uploadTarget"
        class="md-raised md-accent"
        @click.prevent="onSave(fileBlob, 'video')"
      >
        <md-icon>done_all</md-icon>
        Aufnahme jetzt einreichen
      </md-button>
    </div>
  </div>
</template>
<script>
import RecordRTC from "recordrtc";
import { script } from "@/components/recorder/parts/screen.js";
export default {
  components: {},
  props: {
    onSave: Function,
    fileName: String,
    uploadTarget: String
  },
  data() {
    return {
      fileBlob: false
    };
  },
  methods: {
    getDownload() {
      const url = this.fileBlob;
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = this.fileName + ".webm";
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 100);
    },
    getRtc() {
      var s = new script();
      s.RecordRTC = RecordRTC;
      s.video = this.$refs.video;
      s.startBtn = document.getElementById("btn-start-recording");
      s.stopBtn = document.getElementById("btn-stop-recording");
      s.callback = function(data) {
        this.fileBlob = data;
      }.bind(this);
      s.listener();
    }
  },
  mounted() {
    this.getRtc();
  },
  computed: {}
};
</script>
<style lang="sass" scoped>
.container
  text-align: center
  margin: 20px 0
  box-sizing: border-box
  .md-raised:disabled
    display: none
  .videoscreen
    width: 500px
    margin: 10px 0
    box-sizing: border-box
    &.hidden
      display: none
  @media (max-width: 500px)
    .videoscreen
      width: 100%
</style>
